import { Alert, AlertCircle, CheckCircle, Information } from '@opengov/react-capital-assets';
import type { ResultStatus } from '../types';

/**
 * Maps ResultStatus to icon and MUI theme palette shorthand color.
 */
export const STATUS_ICON_COLOR_MAP = {
  empty: {
    icon: AlertCircle,
    color: 'text.disabled'
  },
  error: {
    icon: AlertCircle,
    color: 'error.main'
  },
  success: {
    icon: CheckCircle,
    color: 'success.main'
  },
  warning: {
    icon: Alert,
    color: 'warning.main'
  },
  info: {
    icon: Information,
    color: 'info.main'
  }
};

/**
 * Returns the icon and palette color shorthand for a given status.
 * @param status - The Result status
 */
export function getStatusIconAndColor(status: ResultStatus) {
  const map = STATUS_ICON_COLOR_MAP;
  return map[status] || map.empty;
}
